<bn-loading-overlay></bn-loading-overlay>

<div class="row">
    <div class="col">
      <h3>
        Janela de Apuração
        <small *ngIf="model?.id" class="text-muted">(#ID: {{ model.id }})</small>
      </h3>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-primary" [disabled]="pesquisado" (click)="verificarVoltaParaLista()"
        [ngClass]="formJanela.pristine ? 'btn-primary' : 'btn-danger' ">
        {{ modoEdicao ? "Cancelar" : "Voltar"}}
      </button>

      <button *ngIf="modoEdicao" type="button" class="btn btn-primary"
        [disabled]="!permissaoEdicao || !formJanela.valid " (click)="salvar()">Salvar
      </button>

      <button *ngIf="!modoEdicao && permissaoEdicao"
              type="button" class="btn btn-primary" [disabled]="pesquisado" 
              (click)="habilitarEdicao()">Editar
      </button>
    </div>
  </div>

  <div *ngIf="formJanela" [formGroup]="formJanela">
          <div class="row">

            <div class="bn-form-group col-md-3">
                <label><b>Cesta:</b> </label>
                <select  type="text" id="ideTranche" class="form-select" formControlName="ideTranche" [attr.disabled]="!modoEdicao ? true : null || !podeEditarTudo ? true : null">
                  <option [value]="tranche.id" *ngFor="let tranche of tranches">
                    {{recuperarNumeroTranche(tranche.id)}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
                </select>
              </div>

            <div class="bn-form-group col-md-3">
              <label><b>Data Início Janela:</b></label>
              <bn-datepicker name="dataInicioJanela"  ngDefaultControl formControlName="dataInicioJanela" 
                [disabled]="!modoEdicao || !podeEditarTudo">
              </bn-datepicker>
            </div>
            <div class="bn-form-group col-md-3">
                <label><b>Data Fim Janela:</b></label>
                <bn-datepicker name="dataFimJanela" [minDate]="dataInicioJanelaValidacao" ngDefaultControl formControlName="dataFimJanela"
                  [disabled]="!modoEdicao">
                </bn-datepicker>
              </div>
            <div class="bn-form-group col-md-3">
                <label><b>Data Fim Execução:</b></label>
                <bn-datepicker name="dataFimExecucao" [minDate]="dataFimJanelaValidacao" ngDefaultControl formControlName="dataFimExecucao"
                  [disabled]="!modoEdicao">
                </bn-datepicker>
              </div>
              </div>
              <div *ngIf="model?.id" class="row">
              <div class="bn-form-group col-md-3">
                <label><b>Data Última Execução:</b></label>
                  <bn-datepicker name="dataUltimaExecucao" ngDefaultControl formControlName="dataUltimaExecucao">
                  </bn-datepicker>
              </div>

              <div  class="bn-form-group col-md-3">
                <label><b>Data Criação:</b></label>
                <bn-datepicker name="dataCriacao" ngDefaultControl formControlName="dataCriacao">
                </bn-datepicker>
              </div>

              <div  class="bn-form-group col-md-3">
                <label for="usuarioResponsavel"><b>Usuário responsável:</b></label>
                <input id="usuarioResponsavel" type="text" class="form-control" formControlName="usuarioResponsavel">
              </div>

          </div>
  </div>